<template>
    <v-app>
        <template v-if="showShell">
            <sidebar v-model="drawer" />
            <v-app-bar app flat color="white" class="app-bar">
                <v-app-bar-nav-icon class="hidden-lg-and-up" @click="drawer = !drawer" />
                <v-toolbar-title class="app-bar-title">{{ $route.meta.title }}</v-toolbar-title>
                <v-spacer />
                <v-chip small outlined color="primary" class="mr-3 hidden-xs-only">
                    <v-icon left small>{{ isDealer ? 'mdi-handshake-outline' : 'mdi-shield-account-outline' }}</v-icon>
                    {{ isDealer ? 'Dealer' : 'Administrator' }}
                </v-chip>
                <v-btn text color="primary" @click="logout">
                    <v-icon left>mdi-logout</v-icon>
                    <span class="hidden-xs-only">Logout</span>
                </v-btn>
            </v-app-bar>
        </template>
        <v-main>
            <!-- keyed by path so /x/1/show -> /x/1/edit remounts the form, while page changes on a list do not -->
            <router-view :key="$route.path" />
        </v-main>
        <app-snackbar />
    </v-app>
</template>

<script>
    import Sidebar from '@/components/Sidebar'
    import AppSnackbar from '@/components/AppSnackbar'

    export default {
        name: 'App',
        components: {
            Sidebar,
            AppSnackbar
        },
        data: () => ({
            drawer: null
        }),
        computed: {
            showShell() {
                return this.$store.getters.isLoggedIn && !this.$route.meta.public && !!this.$route.name
            },
            isDealer() {
                return this.$store.getters.isDealer
            }
        },
        methods: {
            logout() {
                this.$store.dispatch('logout')
                this.$router.push('/login')
            }
        }
    }
</script>

<style>
.v-application {
    background-color: var(--v-background-base) !important;
}

.app-bar {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.app-bar-title {
    font-weight: 600;
    color: var(--v-primary-base);
}

.page-container {
    max-width: 1600px;
    padding: 24px;
}

@media (max-width: 600px) {
    .page-container {
        padding: 12px;
    }
}

.form-container {
    max-width: 1100px;
    padding: 24px;
}

.clickable-rows tbody tr:not(.v-data-table__empty-wrapper) {
    cursor: pointer;
}

.list-table th {
    white-space: nowrap;
}

.list-table td {
    white-space: nowrap;
}

.list-table td.wrap {
    white-space: normal;
    min-width: 220px;
}

.section-title {
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.6);
}

.editor-label {
    display: block;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 6px;
}

.checkbox-row {
    gap: 4px 24px;
}

/* sticks to the bottom of long forms so Save is always reachable */
.form-actions {
    position: sticky;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 0;
    background: var(--v-background-base);
}

/* TinyMCE: these used to be redefined (differently) in several components */
.tox .tox-editor-header {
    z-index: 0 !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}

.tox.tox-tinymce {
    border-radius: 4px;
}
</style>
